import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'stc-apps-account-verified',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './account-verified.component.html',
  styleUrl: './account-verified.component.scss',
})
export class AccountVerifiedComponent implements OnInit {
  userName: string | null = null;
  ngOnInit(): void {
    this.userName = localStorage.getItem('setupUserName');
    localStorage.removeItem('setupUserName');
  }
}
